import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { ShortIdPipe } from '@rocketfinancialcorp/rocket-ui/table';
import { NotAvailablePipe } from '@shared/pipes';

@Component({
  selector: 'app-details-item-id',
  templateUrl: './details-item-id.component.html',
  standalone: true,
  imports: [RktIconComponent, RouterLink, ShortIdPipe, NotAvailablePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsItemIdComponent {
  label = input.required<string>();
  id = input<string>();
  link = input<string[]>();

  copyFlag = signal(false);

  copyToClipboard(): void {
    this.copyFlag.set(true);
    navigator.clipboard.writeText(this.id() ?? '');
    setTimeout(() => {
      this.copyFlag.set(false);
    }, 1000);
  }
}
